import React, { useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'

interface PortalProps {
  children: React.ReactNode
}

export default function Portal({ children }: PortalProps) {
  const portalRoot = useRef<HTMLElement | null>(null)
  const el = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    // Create portal root if it doesn't exist
    if (!portalRoot.current) {
      const div = document.createElement('div')
      div.setAttribute('id', 'portal-root')
      document.body.appendChild(div)
      portalRoot.current = div
    }

    // Create element to portal into
    el.current = document.createElement('div')

    // Append to portal root
    portalRoot.current.appendChild(el.current)

    // Cleanup
    return () => {
      if (el.current && portalRoot.current) {
        portalRoot.current.removeChild(el.current)
      }
    }
  }, [])

  // Return portal if element exists
  return el.current ? createPortal(children, el.current) : null
}
